/** Analytics dashboard chart colors, styles, and bond-type metadata (Phase 9.13F). */

export const ANALYTICS_COLORS = {
  login: '#4CAF50',
  register: '#2196F3',
  bond_action: '#FF9800',
  create: '#00C851',
  cancel: '#FF3547',
  endorse: '#9C27B0',
  primary: '#1976d2',
  secondary: '#dc004e',
  gradient: {
    primary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    success: 'linear-gradient(135deg, #4CAF50 0%, #8BC34A 100%)',
    warning: 'linear-gradient(135deg, #FF9800 0%, #FFC107 100%)',
    error: 'linear-gradient(135deg, #FF3547 0%, #FF5722 100%)',
    info: 'linear-gradient(135deg, #2196F3 0%, #21CBF3 100%)',
    purple: 'linear-gradient(135deg, #9C27B0 0%, #E91E63 100%)',
    ocean: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    sunset: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    forest: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  },
};

export const ANALYTICS_GRADIENT_COLORS = [
  '#667eea', '#764ba2', '#f093fb', '#f5576c', '#4facfe', '#00f2fe', '#43e97b', '#38f9d7',
];

export const ANALYTICS_CHART_COLORS = {
  logins: '#4CAF50',
  registrations: '#2196F3',
  bondsCreated: '#00C851',
  bondsCancelled: '#FF3547',
  bondsEndorsed: '#2196F3',
  totalActions: '#667eea',
};

export const ANALYTICS_BOND_TYPES = ['Probate', 'Guardianship', 'Trustee', 'VA', 'Blanket'];

export const ANALYTICS_STACKED_BOND_BARS = [
  { dataKey: 'Probate', name: 'Probate', fill: '#5B8FF9' },
  { dataKey: 'Guardianship', name: 'Guardianship', fill: '#61DDAA' },
  { dataKey: 'Trustee', name: 'Trustee', fill: '#65789B' },
  { dataKey: 'VA', name: 'VA', fill: '#F6BD16' },
  { dataKey: 'Blanket', name: 'Blanket', fill: '#7262fd' },
];

export const ANALYTICS_BOND_CREATION_BARS = [
  { dataKey: 'probateBonds', gradientId: 'probateGradient', name: 'Probate Bonds' },
  { dataKey: 'guardianshipBonds', gradientId: 'guardianshipGradient', name: 'Guardianship Bonds' },
  { dataKey: 'trusteeBonds', gradientId: 'trusteeGradient', name: 'Trustee Bonds' },
  { dataKey: 'vaBonds', gradientId: 'vaGradient', name: 'VA Bonds' },
  { dataKey: 'blanketBonds', gradientId: 'blanketGradient', name: 'Blanket Bonds' },
];

export const ANALYTICS_BOND_TYPE_CHIP_CONFIG = [
  { metricKey: 'probateBonds', label: 'Probate' },
  { metricKey: 'guardianshipBonds', label: 'Guardianship' },
  { metricKey: 'trusteeBonds', label: 'Trustee' },
  { metricKey: 'vaBonds', label: 'VA' },
  { metricKey: 'blanketBonds', label: 'Blanket' },
];

export const ANALYTICS_CHART_CARD_SX = {
  borderRadius: '16px',
  background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
  boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
  border: '1px solid rgba(255,255,255,0.2)',
};

export const ANALYTICS_CHART_INNER_BOX_SX = {
  background: '#ffffff',
  borderRadius: '12px',
  p: 2,
  border: '1px solid #f0f0f0',
};

export const ANALYTICS_CHART_TITLE_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  fontWeight: 'bold',
  color: '#333',
  mb: 3,
};

export const ANALYTICS_AXIS_TICK = { fontSize: 13, fill: '#555', fontWeight: 500 };
export const ANALYTICS_AXIS_LINE = { stroke: '#ddd', strokeWidth: 1 };
export const ANALYTICS_GRID_PROPS = {
  strokeDasharray: '2 2',
  stroke: '#e3f2fd',
  strokeOpacity: 0.6,
  horizontal: true,
  vertical: false,
};

export const ANALYTICS_TOOLTIP_CONTENT_STYLE = {
  backgroundColor: '#fff',
  border: 'none',
  borderRadius: '12px',
  boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
  fontSize: '14px',
  fontWeight: 500,
  padding: '12px 16px',
};

export const ANALYTICS_TOOLTIP_CURSOR = {
  fill: 'rgba(102, 126, 234, 0.08)',
  stroke: 'rgba(102, 126, 234, 0.3)',
  strokeWidth: 2,
  strokeDasharray: '5 5',
};

export const ANALYTICS_LEGEND_WRAPPER_STYLE = {
  paddingTop: '20px',
  fontSize: '14px',
  fontWeight: '500',
};

export const ANALYTICS_CHART_MARGIN = { top: 20, right: 30, left: 20, bottom: 5 };

export const ANALYTICS_SLAB_ROWS_TEMPLATE = [
  { slab: '0-50k', total: 0, Probate: 0, Guardianship: 0, Trustee: 0, VA: 0, Blanket: 0 },
  { slab: '50k-250k', total: 0, Probate: 0, Guardianship: 0, Trustee: 0, VA: 0, Blanket: 0 },
  { slab: '250k-500k', total: 0, Probate: 0, Guardianship: 0, Trustee: 0, VA: 0, Blanket: 0 },
  { slab: '500k+', total: 0, Probate: 0, Guardianship: 0, Trustee: 0, VA: 0, Blanket: 0 },
];

export function createAnalyticsSlabRows() {
  return ANALYTICS_SLAB_ROWS_TEMPLATE.map((row) => ({ ...row }));
}

export function pickBondAmountSlabIndex(amount) {
  if (amount < 50000) return 0;
  if (amount < 250000) return 1;
  if (amount <= 500000) return 2;
  return 3;
}
